import { createI18n } from 'vue-i18n'
import { DEFAULT_LOCALE, localeByCode } from './locales.js'
import en from './messages/en.js'
import tl from './messages/tl.js'
import ceb from './messages/ceb.js'
import th from './messages/th.js'
import vi from './messages/vi.js'

/**
 * Translations for the public site and the sign-in flow.
 *
 * English is the source. A key missing from another language falls back to
 * it silently rather than warning in the console, because a page that
 * shows one English line is better than one that logs four hundred
 * warnings. Numbers and money keep their en-US shape everywhere: figures
 * are read the same way in every market this panel sells into, and a
 * per-locale decimal comma would make prices look different from the
 * receipts.
 */
export const i18n = createI18n({
  legacy: false,
  locale: DEFAULT_LOCALE,
  fallbackLocale: DEFAULT_LOCALE,
  messages: { en, tl, ceb, th, vi },
  missingWarn: false,
  fallbackWarn: false,
})

const STORAGE_KEY = 'pr.locale'

export function readStoredLocale() {
  try {
    return localStorage.getItem(STORAGE_KEY) ?? ''
  } catch {
    return ''
  }
}

/** Switches the active language and records it as the visitor's choice. */
export function setLocale(code, { remember = true } = {}) {
  const locale = localeByCode(code)
  i18n.global.locale.value = locale.code
  document.documentElement.lang = locale.htmlLang
  if (remember) {
    try {
      localStorage.setItem(STORAGE_KEY, locale.code)
    } catch {
      /* private mode */
    }
  }
  return locale
}

export const t = (...args) => i18n.global.t(...args)
